<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Nov prostor:
    </h2>

    <LocationForm
      @save="save"
      @cancel="cancel"
      ref="form"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import LocationForm from '@/components/LocationForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  components: {
    LocationForm
  },
  mixins: [
    asyncDataStatus
  ],
  methods: {
    ...mapActions('locations', ['saveItem']),
    save ({ data, repeat = false }) {
      const redirect = repeat ? null : 'MyCompanyLocations'
      this.saveItem({ id: this.id, ...data })
        .then(item => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
          if (redirect) {
            this.$router.push({ name: redirect })
          } else {
            this.$refs.form.clearForm()
          }
        })
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyLocations' })
    }
  },
  created () {
    this.asyncDataStatus_fetched()
  }
}
</script>
